<template>
  <!-- Residual risk over time as a line, with the tolerance dashed (US 9370) -->
  <svg class="rk-spark" :width="width" :height="height" :viewBox="'0 0 ' + width + ' ' + height" role="img" :aria-label="label">
    <line v-if="tolerance" x1="2" :x2="width - 2" :y1="y(tolerance)" :y2="y(tolerance)" class="rk-spark__tol"/>
    <polyline v-if="points.length > 1" class="rk-spark__line" :points="line"/>
    <circle v-if="points.length" :cx="x(points.length - 1)" :cy="y(points[points.length - 1])" r="3" class="rk-spark__dot"/>
  </svg>
</template>

<script>
  export default {
    name: 'RiskSparkline',
    props: {
      points: { type: Array, default: () => [] },
      max: { type: Number, required: true },
      tolerance: { type: Number, default: null },
      width: { type: Number, default: 110 },
      height: { type: Number, default: 30 }
    },
    computed: {
      line() {
        return this.points.map((value, index) => this.x(index) + ',' + this.y(value)).join(' ');
      },
      label() {
        return this.points.join(' → ');
      }
    },
    methods: {
      x(index) {
        return this.points.length < 2 ? this.width - 6 : 4 + index * (this.width - 10) / (this.points.length - 1);
      },
      y(value) {
        return this.height - 4 - (value / this.max) * (this.height - 8);
      }
    }
  }
</script>
